import { render } from "./StatsWidgetDataConfig.vue?vue&type=template&id=5a1b44af"
import script from "./StatsWidgetDataConfig.vue?vue&type=script&lang=ts"
export * from "./StatsWidgetDataConfig.vue?vue&type=script&lang=ts"

import "./StatsWidgetDataConfig.vue?vue&type=style&index=0&id=5a1b44af&lang=scss"
script.render = render

export default script